import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (sessionStorage.getItem('consumerLogin') != null){
          console.log('Yes LoggedIn! canActivate');
          return true;
      }else{
        if (sessionStorage.getItem('userLogin') != null || sessionStorage.getItem('subscriberLogin') != null) {
          console.log('Yes LoggedIn! canActivate');
          return true;
        } else {
          console.warn('Not LoggedIn! canActivate');
          this.router.navigate(['/login']);
          return false;
        }
      }

  }
  constructor(private router: Router) { }
}
